import React from 'react'

import SubscriptionModals from './components/SubscriptionModals/SubscriptionModals'


const SubscriptionLayout: React.CFC = ({ children }) => {
  return (
    <>
      {children}
      <SubscriptionModals />
    </>
  )
}


export default SubscriptionLayout
